import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommercialPrintComponent } from './commercial-print.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { QuickAddModule } from 'app/main/master-data/accounts/quick-add/quick-add.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TINYMCE_SCRIPT_SRC, EditorModule } from '@tinymce/tinymce-angular';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [CommercialPrintComponent],
  imports: [
    CommonModule,
    FuseSharedModule,
    MatButtonModule,
    MatSlideToggleModule,
    NgSelectModule,
    MatRadioModule,
    MatIconModule,
    MatFormFieldModule,
    MatDividerModule,
    MatAutocompleteModule,
    MatTooltipModule,
    QuickAddModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatToolbarModule,
    EditorModule,
    TranslateModule,
  ],
  exports: [CommercialPrintComponent],
  providers: [
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }
  ]
})
export class CommercialPrintModule { }
